export type BadgeProps = {
    color?:
        | 'primary'
        | 'secondary'
        | 'success'
        | 'danger'
        | 'warning'
        | 'info'
        | 'light'
        | 'dark';
    className?: string;
    type?: 'button';
    onClick?: (event: React.MouseEvent) => void;
    children;
};

const classMapping = {
    primary: 'badge-primary',
    secondary: 'badge-secondary',
    success: 'badge-success',
    danger: 'badge-danger',
    warning: 'badge-warning',
    info: 'badge-info',
    light: 'badge-light',
    dark: 'badge-dark'
};

const renderChildren = (rootClass, props, children) => (
    <span className={rootClass} {...props}>
        {children}
    </span>
);

const Badge = ({
    color = 'primary',
    className,
    type,
    onClick,
    children,
    ...props
}: BadgeProps) => {
    let rootClass = `badge ${classMapping[color]} ${className ?? ''}`;
    rootClass += ['light'].includes(color) ? ' text-dark' : '';

    switch (type) {
        case 'button':
            return (
                <button
                    className={`${rootClass} border-0`}
                    {...props}
                    onClick={onClick}>
                    {children}
                </button>
            );

        default:
            return renderChildren(rootClass, props, children);
    }
};

export default Badge;
